import { render } from "./EditClientForm.vue?vue&type=template&id=ed975440"
import script from "./EditClientForm.vue?vue&type=script&lang=js"
export * from "./EditClientForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__